export const mapValidationNodes = <T>(model: Record<string, unknown>): T => {
    const result: Record<string, unknown> = {};

    for (const key in model) {
        if (Object.prototype.hasOwnProperty.call(model, key)) {
            const value = model[key];
            // This regex splits the key into parts, handling object properties and array indices.
            // e.g., "timeAccess[0].timeAccessType" -> ["timeAccess", "0", "timeAccessType"]
            const pathParts = key.match(/[^.[\]]+/g);

            if (!pathParts) {
                result[key] = value;
                continue;
            }

            let currentLevel: Record<string, unknown> = result;
            for (let i = 0; i < pathParts.length - 1; i++) {
                const part = pathParts[i];
                const nextPart = pathParts[i + 1];

                // Check if the next part of the key is a number, which indicates an array index.
                const isNextPartArrayIndex = /^\d+$/.test(nextPart);

                if (currentLevel[part] === undefined) {
                    currentLevel[part] = isNextPartArrayIndex ? [] : {};
                }
                currentLevel = currentLevel[part] as Record<string, unknown>;
            }

            const lastPart = pathParts[pathParts.length - 1];
            currentLevel[lastPart] = value;
        }
    }
    return result as T;
};
